import { render, staticRenderFns } from "./file_download.vue?vue&type=template&id=4b2d90e7"
import script from "./file_download.vue?vue&type=script&lang=js"
export * from "./file_download.vue?vue&type=script&lang=js"
import style0 from "./file_download.vue?vue&type=style&index=0&id=4b2d90e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports